import type { MediaHeaderBox } from '../boxes/MediaHeaderBox.ts'
import type { IsoBoxReadView } from '../IsoBoxReadView.ts'

/**
 * Parse a `MediaHeaderBox` from an `IsoBoxReadView`.
 *
 * @param view - The `IsoBoxReadView` to read data from
 *
 * @returns A parsed `MediaHeaderBox`
 *
 * @public
 */
export function readMdhd(view: IsoBoxReadView): MediaHeaderBox {
	const { version, flags } = view.readFullBox()

	const creationTime = view.readUint(version == 1 ? 8 : 4)
	const modificationTime = view.readUint(version == 1 ? 8 : 4)
	const timescale = view.readUint(4)
	const duration = view.readUint(version == 1 ? 8 : 4)
	const lang = view.readUint(2)
	const language = String.fromCharCode(((lang >> 10) & 0x1F) + 0x60,
		((lang >> 5) & 0x1F) + 0x60,
		(lang & 0x1F) + 0x60)

	const preDefined = view.readUint(2)

	return {
		type: 'mdhd',
		version,
		flags,
		creationTime,
		modificationTime,
		timescale,
		duration,
		language,
		preDefined,
	}
}
